export const STOPWATCH_TIME_START = 'STOPWATCH_TIME_START';
export const STOPWATCH_TIME_STOP = 'STOPWATCH_TIME_STOP';